import type { Column, RowData, TableFeature } from '@tanstack/vue-table';

export interface ColumnOrderingColumnDefExtension {
	/**
	 * Enables or disables column ordering for this column.
	 * @defaultValue true
	 */
	enableOrdering?: boolean;
}

export interface ColumnOrderingColumnExtension {
	/**
	 * Returns `true` if the column can be reordered.
	 */
	getCanReorder: () => boolean;
}

declare module '@tanstack/vue-table' {
	// eslint-disable-next-line unused-imports/no-unused-vars
	interface ColumnDefBase<TData extends RowData, TValue = unknown> extends ColumnOrderingColumnDefExtension {}

	// eslint-disable-next-line unused-imports/no-unused-vars
	interface Column<TData extends RowData, TValue> extends ColumnOrderingColumnExtension {}
}

/**
 * Column Ordering Extension Feature
 *
 * This feature extends @tanstack/table to allow granular control over which columns
 * can be reordered. By default, all columns are orderable unless explicitly disabled
 * via `enableOrdering: false` in the column definition.
 */
export const ColumnOrderingExtension: TableFeature = {
	getDefaultColumnDef: () => {
		return {
			enableOrdering: true,
		};
	},

	createColumn: <TData extends RowData, TValue = unknown>(
		column: Column<TData, TValue>,
		_table: any,
	) => {
		column.getCanReorder = () => {
			return column.columnDef.enableOrdering ?? true;
		};
	},
};
